<div class="modal-header">
  <h4 class="modal-title">{{title}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()">
  </button>
</div>
<div class="modal-body">
  <ng-content></ng-content>
</div>
